import { useEffect, useState } from "react";
// import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { RadioButton } from "primereact/radiobutton";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { AutoComplete } from "primereact/autocomplete";
import { Calendar } from "primereact/calendar";
import { useSearchFilters } from "./SearchFilterContext";
import { radiusOptions, RESUME_UPDATED_OPTIONS, TARGET_JOB_TYPE_OPTIONS } from "./searchOptions";
import { Accordion, AccordionTab } from "primereact/accordion";
// import { Chips } from "primereact/chips";
// import { WorkAuthorization } from "./CandidateResult";
// const resumeUpdatedOptions = [
//   { label: "All Resumes", value: "all" },
//   { label: "Last 24 Hours", value: "24h" },
//   { label: "Last 7 Days", value: "7d" },
//   { label: "Last 30 Days", value: "30d" },
//   { label: "Last 90 Days", value: "90d" },
// ];
//  const salaryPerOptions = [
//   { label: "Per Year", value: "per_year" },
//   // { label: "Per Hour", value: "per_hour" },
// ];
// ─── Props ────────────────────────────────────────────────────────────────────

// interface AdvancedOptionsProps {
//   visible: boolean;
//   onHide: () => void;
//   onSearch: () => void;
// }

// type LocationType = {
//   State: string;
//   City: string;
//   // Zip: string;
// };

// interface SkillEntry {
//   id: number;
//   name: string;
//   importance: "Required" | "NiceToHave";
// }

// const resumeUpdatedMaxOptions = [
//   { label: "Any time", value: "" },
//   { label: "Last 24 hours", value: "1440" },
//   { label: "Last 3 days", value: "4320" },
//   { label: "Last week", value: "10080" },
//   { label: "Last 2 weeks", value: "20160" },
//   { label: "Last month", value: "43200" },
//   { label: "Last 3 months", value: "129600" },
//   { label: "Last 6 months", value: "259200" },
//   { label: "Last year", value: "525600" },
// ];

// const lastActiveOptions = [
//   { label: "Any time", value: "" },
//   { label: "Last 24 hours", value: "1440" },
//   { label: "Last 3 days", value: "4320" },
//   { label: "Last week", value: "10080" },
//   { label: "Last 2 weeks", value: "20160" },
//   { label: "Last month", value: "43200" },
//   { label: "Last 3 months", value: "129600" },
// ];

// const languageOptions = [
//   { label: "English", value: "en" },
//   { label: "French", value: "fr" },
//   { label: "Spanish", value: "es" },
//   { label: "German", value: "de" },
//   { label: "Portuguese", value: "pt" },
//   { label: "Italian", value: "it" },
//   { label: "Mandarin", value: "zh" },
//   { label: "Japanese", value: "ja" },
//   { label: "Arabic", value: "ar" },
//   { label: "Russian", value: "ru" },
// ];

// const proficiencyOptions = [
//   { label: "Unknown", value: "Unknown" },
//   { label: "Beginner", value: "Beginner" },
//   { label: "Intermediate", value: "Intermediate" },
//   { label: "Advanced", value: "Advanced" },
//   { label: "Fluent", value: "Fluent" },
// ];

// const jobTenureOptions = [
//   { label: "Any", value: "" },
//   { label: "6 months", value: "0.5" },
//   { label: "1 year", value: "1" },
//   { label: "2 years", value: "2" },
//   { label: "3 years", value: "3" },
//   { label: "5 years", value: "5" },
// ];

const TabHeader = ({ icon, label }: { icon: string; label: string }) => (
  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    <div style={{ width: "22px", height: "22px", borderRadius: "6px", background: "linear-gradient(135deg, #C88BFF, #9333EA)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
      <i className={`pi ${icon}`} style={{ fontSize: "11px", color: "#fff" }} />
    </div>
    <span style={{ fontSize: "12px", fontWeight: 700, color: "#1a1a2e", textTransform: "uppercase", letterSpacing: "0.05em" }}>{label}</span>
  </div>
);

const MonsterAccordionStyles = () => (
  <style>{`
    .monster-accordion .p-accordion-header-link {
      background: linear-gradient(135deg, #f5f0ff 0%, #faf8ff 100%) !important;
      border: 1px solid #ede8f8 !important;
      border-radius: 8px !important;
      padding: 10px 14px !important;
      box-shadow: none !important;
    }
    .monster-accordion .p-accordion-header:not(.p-disabled).p-highlight .p-accordion-header-link {
      background: linear-gradient(135deg, #ede9fe 0%, #f5f0ff 100%) !important;
      border-color: #C88BFF !important;
    }
    .monster-accordion .p-accordion-header-link:focus {
      box-shadow: 0 0 0 2px rgba(147, 51, 234, 0.25) !important;
    }
    .monster-accordion .p-accordion-content {
      border: 1px solid #ede8f8 !important;
      border-top: none !important;
      border-radius: 0 0 8px 8px !important;
      padding: 16px !important;
    }
    .monster-accordion .p-accordion-tab {
      margin-bottom: 10px;
    }
    .monster-accordion .p-accordion-toggle-icon {
      color: #7c3aed !important;
    }
  `}</style>
);

// ─── Section Header ────────────────────────────────────────────────────────────

// const SectionHeader = ({ title, expanded, onToggle }: { title: string; expanded: boolean; onToggle: () => void }) => (
//   <div className="flex align-items-center justify-content-between" style={{ cursor: "pointer", marginBottom: "10px", userSelect: "none" }} onClick={onToggle}>
//     <span style={{ fontSize: "12px", fontWeight: 700, color: "#1a1a2e", textTransform: "uppercase", letterSpacing: "0.05em" }}>{title}</span>
//     <i className={`pi ${expanded ? "pi-chevron-up" : "pi-chevron-down"}`} style={{ fontSize: "11px", color: "#888" }} />
//   </div>
// );

// ─── Language Row ──────────────────────────────────────────────────────────────

// interface LangEntry {
//   languageCode: string;
//   proficiency: string;
// }

// const LanguageProficiencyEditor = ({ entries, onChange }: { entries: LangEntry[]; onChange: (entries: LangEntry[]) => void }) => {
//   const addRow = () => onChange([...entries, { languageCode: "en", proficiency: "Intermediate" }]);
//   const removeRow = (i: number) => onChange(entries.filter((_, idx) => idx !== i));
//   const updateRow = (i: number, field: keyof LangEntry, value: string) => onChange(entries.map((e, idx) => (idx === i ? { ...e, [field]: value } : e)));

//   return (
//     <div>
//       {entries.map((entry, i) => (
//         <div key={i} className="flex align-items-center gap-2 mb-2">
//           <Dropdown value={entry.languageCode} options={languageOptions} onChange={(e) => updateRow(i, "languageCode", e.value)} style={{ fontSize: "12px", flex: 1 }} className="w-full" />
//           <Dropdown value={entry.proficiency} options={proficiencyOptions} onChange={(e) => updateRow(i, "proficiency", e.value)} style={{ fontSize: "12px", flex: 1 }} className="w-full" />
//           <Button icon="pi pi-times" className="p-button-text p-button-sm p-button-danger p-0" style={{ width: "20px", height: "20px" }} onClick={() => removeRow(i)} />
//         </div>
//       ))}
//       <Button label="+ Add Language" className="p-button-text p-button-sm p-0" style={{ fontSize: "12px", color: "#2563eb" }} onClick={addRow} />
//     </div>
//   );
// };

// ─── Degree Row ────────────────────────────────────────────────────────────────

interface DegreeEntry {
  degreeName: string;
  importance: "Required" | "NiceToHave";
}

const DegreesEditor = ({ entries, onChange }: { entries: DegreeEntry[]; onChange: (entries: DegreeEntry[]) => void }) => {
  const addRow = () => onChange([...entries, { degreeName: "", importance: "NiceToHave" }]);
  const removeRow = (i: number) => onChange(entries.filter((_, idx) => idx !== i));
  const updateRow = (i: number, field: keyof DegreeEntry, value: string) => onChange(entries.map((e, idx) => (idx === i ? { ...e, [field]: value } : e)));

  return (
    <div>
      {entries.map((entry, i) => (
        <div key={i} className="flex align-items-center gap-2 mb-2">
          <InputText value={entry.degreeName} onChange={(e) => updateRow(i, "degreeName", e.target.value)} placeholder="e.g., MBA, Computer Science" style={{ fontSize: "12px", flex: 1 }} className="w-full" />
          <div className="flex align-items-center gap-1">
            <Checkbox inputId={`deg_req_${i}`} checked={entry.importance === "Required"} onChange={(e) => updateRow(i, "importance", e.checked ? "Required" : "NiceToHave")} />
            <label htmlFor={`deg_req_${i}`} style={{ fontSize: "11px", cursor: "pointer", whiteSpace: "nowrap" }}>
              Req.
            </label>
          </div>
          <Button icon="pi pi-times" className="p-button-text p-button-sm p-button-danger p-0" style={{ width: "20px", height: "20px" }} onClick={() => removeRow(i)} />
        </div>
      ))}
      <Button label="+ Add Degree" className="p-button-text p-button-sm p-0" style={{ fontSize: "12px", color: "#2563eb" }} onClick={addRow} />
    </div>
  );
};

// ─── Component ────────────────────────────────────────────────────────────────

// const AdvancedOptions = ({ visible, onHide, onSearch }: AdvancedOptionsProps) => {
//   const [limitRelocate, setLimitRelocate] = useState(false);
//   const [limitVeterans, setLimitVeterans] = useState(false);
//   const [workAuth, setWorkAuth] = useState("all");

//   // const [careerLevel, setCareerLevel] = useState<Record<string, boolean>>({
//   //   executiveLevel: false,
//   //   vicePresident: false,
//   //   director: false,
//   //   manager: false,
//   // });

//   // Job Duration
//   const [jobDuration, setJobDuration] = useState("");

//   // Years of Experience
//   const [yearsExp, setYearsExp] = useState("");
//   const [expRequired, setExpRequired] = useState(false);

//   // Profile Search Criteria
//   const [resumeUpdated, setResumeUpdated] = useState("all");
//   const [candidateName, setCandidateName] = useState("");

//   // Job Type
//   const [jobType, setJobType] = useState<Record<string, boolean>>({
//     fullTime: false,
//     tempContract: false,
//     intern: false,
//     partTime: false,
//     seasonal: false,
//   });

//   // Citizenship
//   const [citizenship, setCitizenship] = useState<Record<string, boolean>>({
//     usCitizen: false,
//     permanentResident: false,
//   });

//   // Security Clearance
//   const [clearance, setClearance] = useState<Record<string, boolean>>({
//     activeConfidential: false,
//     activeSecret: false,
//     activeTopSecret: false,
//     activeTopSecretSCI: false,
//     activeTSSCICIPoly: false,
//     activeTSSCIFSPoly: false,
//     otherActiveClearance: false,
//   });

//   // Desired Candidate Salary
//   const [salaryPer, setSalaryPer] = useState("per_year");
//   const [salaryAmount, setSalaryAmount] = useState("");
//   const [includeWithoutSalary, setIncludeWithoutSalary] = useState(true);

//   // Willing to Travel
//   const [travel, setTravel] = useState("");

//   // Education
//   const [education, setEducation] = useState("");

//   // Section collapse state
//   const [showResumeCriteria, setShowResumeCriteria] = useState(true);
//   const [showProfileCriteria, setShowProfileCriteria] = useState(true);

//   // ── Section Header ──
//   const SectionHeader = ({ title, expanded, onToggle }: { title: string; expanded: boolean; onToggle: () => void }) => (
//     <div className="flex align-items-center gap-2" style={{ cursor: "pointer", marginBottom: "16px" }} onClick={onToggle}>
//       <span style={{ fontSize: "15px", fontWeight: 700, color: "#1a1a2e" }}>{title}</span>
//       <span style={{ fontSize: "16px", color: "#666", fontWeight: 400 }}>{expanded ? "—" : "+"}</span>
//     </div>
//   );

//   // ── Footer ──
//   const footer = (
//     <div className="flex justify-content-end gap-2" style={{ padding: "8px 0" }}>
//       <Button label="Cancel" className="p-button-text" style={{ color: "#6b7280" }} onClick={onHide} />
//       <Button label="Search" onClick={onSearch} style={{ backgroundColor: "#6f42c1", border: "none", padding: "10px 32px", fontWeight: 600 }} />
//     </div>
//   );

//   return (
//     <Dialog header="Advanced Options" visible={visible} onHide={onHide} footer={footer} style={{ width: "90vw", maxWidth: "1400px" }} maximizable draggable={false} headerStyle={{ fontSize: "18px", fontWeight: 700, color: "#1a1a2e" }}>
//       <div style={{ fontSize: "13px", color: "#333" }}>
//         {/* ══ ROW 1: Candidate Types + Work Authorization ══ */}
//         <div className="flex gap-6 mb-5" style={{ borderBottom: "1px solid #e9ecef", paddingBottom: "24px" }}>
//           {/* Select Candidate Types */}
//           <div style={{ flex: 1 }}>
//             <div style={{ fontSize: "14px", fontWeight: 700, color: "#1a1a2e", marginBottom: "12px" }}>Select Candidate Types</div>
//             <div className="flex flex-column gap-2">
//               <div className="flex align-items-center gap-2">
//                 <Checkbox inputId="limitRelocate" checked={limitRelocate} onChange={(e) => setLimitRelocate(!!e.checked)} />
//                 <label htmlFor="limitRelocate" style={{ fontSize: "13px", cursor: "pointer" }}>
//                   Limit results to candidates willing to relocate
//                 </label>
//               </div>
//               <div className="flex align-items-center gap-2">
//                 <Checkbox inputId="limitVeterans" checked={limitVeterans} onChange={(e) => setLimitVeterans(!!e.checked)} />
//                 <label htmlFor="limitVeterans" style={{ fontSize: "13px", cursor: "pointer" }}>
//                   Limit results to candidates designated as veterans
//                 </label>
//               </div>
//             </div>
//           </div>

//           {/* Work Authorization */}
//           <div style={{ flex: 1 }}>
//             <div style={{ fontSize: "14px", fontWeight: 700, color: "#1a1a2e", marginBottom: "12px" }}>Work Authorization</div>
//             <div className="flex flex-column gap-2">
//               {[
//                 { value: "all", label: "Show all job seekers" },
//                 { value: "authorized_any", label: "Limit to job seekers authorized to work in this country for any employer" },
//                 { value: "authorized_present", label: "Limit to job seekers authorized to work in this country for their present employer only" },
//                 { value: "sponsorship", label: "Limit to job seekers that require sponsorship to work in this country" },
//               ].map((opt) => (
//                 <div key={opt.value} className="flex align-items-center gap-2">
//                   <RadioButton inputId={`wa_${opt.value}`} value={opt.value} checked={workAuth === opt.value} onChange={() => setWorkAuth(opt.value)} />
//                   <label htmlFor={`wa_${opt.value}`} style={{ fontSize: "13px", cursor: "pointer" }}>
//                     {opt.label}
//                   </label>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* ══ Resume Search Criteria ══ */}
//         <div style={{ marginBottom: "24px" }}>
//           <SectionHeader title="Resume Search Criteria" expanded={showResumeCriteria} onToggle={() => setShowResumeCriteria((p) => !p)} />
//           <Divider style={{ margin: "0 0 20px 0" }} />

//           {showResumeCriteria && (
//             <div className="flex gap-6">
//               {/* Career Level */}
//               {/* <div style={{ flex: 1 }}>
//                 <div style={{ fontSize: "13px", fontWeight: 600, color: "#333", marginBottom: "10px" }}>Career Level</div>
//                 <div className="flex flex-column gap-2">
//                   {[
//                     { key: "executiveLevel", label: "Executive Level" },
//                     { key: "vicePresident", label: "Vice President" },
//                     { key: "director", label: "Director" },
//                     { key: "manager", label: "Manager" },
//                   ].map((item) => (
//                     <div key={item.key} className="flex align-items-center gap-2">
//                       <Checkbox inputId={`cl_${item.key}`} checked={careerLevel[item.key]} onChange={(e) => setCareerLevel((prev) => ({ ...prev, [item.key]: !!e.checked }))} />
//                       <label htmlFor={`cl_${item.key}`} style={{ fontSize: "13px", cursor: "pointer" }}>
//                         {item.label}
//                       </label>
//                     </div>
//                   ))}
//                 </div> */}
//               {/* </div> */}

//               {/* Job Duration */}
//               <div style={{ flex: 1 }}>
//                 <div style={{ fontSize: "13px", fontWeight: 600, color: "#333", marginBottom: "10px" }}>Job Duration</div>
//                 <div className="flex flex-column gap-2">
//                   {["1 year", "2 year", "5 year", "10 year"].map((yr) => (
//                     <div key={yr} className="flex align-items-center gap-2">
//                       <RadioButton inputId={`jd_${yr}`} value={yr} checked={jobDuration === yr} onChange={() => setJobDuration(yr)} />
//                       <label htmlFor={`jd_${yr}`} style={{ fontSize: "13px", cursor: "pointer" }}>
//                         {yr}
//                       </label>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               {/* Years of Experience */}
//               <div style={{ flex: 1 }}>
//                 <div style={{ fontSize: "13px", fontWeight: 600, color: "#333", marginBottom: "10px" }}>Years of Experience</div>
//                 <InputText value={yearsExp} onChange={(e) => setYearsExp(e.target.value)} placeholder="(e.g., 4, 2-3, 5+, <8)" className="w-full mb-2" style={{ fontSize: "13px" }} />
//                 <div className="flex align-items-center gap-2">
//                   <Checkbox inputId="expRequired" checked={expRequired} onChange={(e) => setExpRequired(!!e.checked)} />
//                   <label htmlFor="expRequired" style={{ fontSize: "13px", cursor: "pointer" }}>
//                     Required
//                   </label>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>

//         {/* ══ Profile Search Criteria ══ */}
//         <div style={{ marginBottom: "24px" }}>
//           <SectionHeader title="Profile Search Criteria" expanded={showProfileCriteria} onToggle={() => setShowProfileCriteria((p) => !p)} />
//           <Divider style={{ margin: "0 0 16px 0" }} />

//           {showProfileCriteria && (
//             <>
//               {/* Notice */}
//               <div style={{ backgroundColor: "#f8f9fa", border: "1px solid #e9ecef", borderRadius: "4px", padding: "12px 16px", fontSize: "12px", color: "#555", marginBottom: "20px" }}>
//                 Please be advised the search options in this search are derived from the information that may or may not be provided by the candidate as part of their profile. Use of these search options could impact the quality of your overall search results.
//               </div>

//               {/* Resume Updated + Candidate Name + Job Type */}
//               <div className="flex gap-6 mb-5">
//                 <div style={{ flex: 1 }}>
//                   <div style={{ fontSize: "13px", fontWeight: 600, color: "#333", marginBottom: "10px" }}>Resume Updated</div>
//                   <Dropdown value={resumeUpdated} options={resumeUpdatedOptions} onChange={(e) => setResumeUpdated(e.value)} className="w-full" style={{ fontSize: "13px" }} />
//                 </div>
//                 <div style={{ flex: 1 }}>
//                   <div style={{ fontSize: "13px", fontWeight: 600, color: "#333", marginBottom: "10px" }}>Candidate Name</div>
//                   <InputText value={candidateName} onChange={(e) => setCandidateName(e.target.value)} placeholder="(e.g., Mark, John Wayne)" className="w-full" style={{ fontSize: "13px" }} />
//                 </div>
//                 <div style={{ flex: 1 }}>
//                   <div style={{ fontSize: "13px", fontWeight: 600, color: "#333", marginBottom: "10px" }}>Job Type</div>
//                   <div className="flex flex-column gap-2">
//                     {[
//                       { key: "fullTime", label: "Full Time" },
//                       { key: "tempContract", label: "Temporary/Contract" },
//                       { key: "intern", label: "Intern" },
//                       { key: "partTime", label: "Part time" },
//                       { key: "seasonal", label: "Seasonal" },
//                     ].map((item) => (
//                       <div key={item.key} className="flex align-items-center gap-2">
//                         <Checkbox inputId={`jt_${item.key}`} checked={jobType[item.key]} onChange={(e) => setJobType((prev) => ({ ...prev, [item.key]: !!e.checked }))} />
//                         <label htmlFor={`jt_${item.key}`} style={{ fontSize: "13px", cursor: "pointer" }}>
//                           {item.label}
//                         </label>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>

//               <Divider style={{ margin: "0 0 20px 0" }} />

//               {/* Citizenship + Security Clearance + Desired Salary */}
//               <div className="flex gap-6 mb-5">
//                 <div style={{ flex: 1 }}>
//                   <div style={{ fontSize: "13px", fontWeight: 600, color: "#333", marginBottom: "10px" }}>Citizenship</div>
//                   <div className="flex flex-column gap-2">
//                     {[
//                       { key: "usCitizen", label: "US Citizen" },
//                       { key: "permanentResident", label: "Permanent Resident" },
//                     ].map((item) => (
//                       <div key={item.key} className="flex align-items-center gap-2">
//                         <Checkbox inputId={`c_${item.key}`} checked={citizenship[item.key]} onChange={(e) => setCitizenship((prev) => ({ ...prev, [item.key]: !!e.checked }))} />
//                         <label htmlFor={`c_${item.key}`} style={{ fontSize: "13px", cursor: "pointer" }}>
//                           {item.label}
//                         </label>
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 <div style={{ flex: 1 }}>
//                   <div style={{ fontSize: "13px", fontWeight: 600, color: "#333", marginBottom: "10px" }}>Security Clearance</div>
//                   <div className="flex flex-column gap-2">
//                     {[
//                       { key: "activeConfidential", label: "Active Confidential" },
//                       { key: "activeSecret", label: "Active Secret" },
//                       { key: "activeTopSecret", label: "Active Top Secret" },
//                       { key: "activeTopSecretSCI", label: "Active Top Secret/SCI" },
//                       { key: "activeTSSCICIPoly", label: "Active TS/SCI-CI Polygraph" },
//                       { key: "activeTSSCIFSPoly", label: "Active TS/SCI-FS Polygraph" },
//                       { key: "otherActiveClearance", label: "Other Activee Clearance" },
//                     ].map((item) => (
//                       <div key={item.key} className="flex align-items-center gap-2">
//                         <Checkbox inputId={`sc_${item.key}`} checked={clearance[item.key]} onChange={(e) => setClearance((prev) => ({ ...prev, [item.key]: !!e.checked }))} />
//                         <label htmlFor={`sc_${item.key}`} style={{ fontSize: "13px", cursor: "pointer" }}>
//                           {item.label}
//                         </label>
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 <div style={{ flex: 1 }}>
//                   <div style={{ fontSize: "13px", fontWeight: 600, color: "#333", marginBottom: "10px" }}>Desired Candidate Salary</div>
//                   <Dropdown value={salaryPer} options={salaryPerOptions} onChange={(e) => setSalaryPer(e.value)} className="w-full mb-2" style={{ fontSize: "13px" }} />
//                   <Dropdown value={salaryAmount} options={salaryAmountOptions} onChange={(e) => setSalaryAmount(e.value)} className="w-full mb-2" style={{ fontSize: "13px" }} />
//                   <div className="flex align-items-center gap-2">
//                     <Checkbox inputId="inclSalary" checked={includeWithoutSalary} onChange={(e) => setIncludeWithoutSalary(!!e.checked)} />
//                     <label htmlFor="inclSalary" style={{ fontSize: "13px", cursor: "pointer" }}>
//                       Include candidates without salary information
//                     </label>
//                   </div>
//                 </div>
//               </div>

//               <Divider style={{ margin: "0 0 20px 0" }} />

//               {/* Willing to Travel + Education */}
//               <div className="flex gap-6">
//                 <div style={{ flex: 1 }}>
//                   <div style={{ fontSize: "13px", fontWeight: 600, color: "#333", marginBottom: "10px" }}>Willing To Travel</div>
//                   <div className="flex flex-column gap-2">
//                     {[
//                       { value: "25", label: "Up to 25% travel" },
//                       { value: "50", label: "Up to 50% travel" },
//                       { value: "75", label: "Up to 75% travel" },
//                       { value: "100", label: "Up to 100%" },
//                     ].map((opt) => (
//                       <div key={opt.value} className="flex align-items-center gap-2">
//                         <RadioButton inputId={`tr_${opt.value}`} value={opt.value} checked={travel === opt.value} onChange={() => setTravel(opt.value)} />
//                         <label htmlFor={`tr_${opt.value}`} style={{ fontSize: "13px", cursor: "pointer" }}>
//                           {opt.label}
//                         </label>
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 <div style={{ flex: 2 }}>
//                   <div style={{ fontSize: "13px", fontWeight: 600, color: "#333", marginBottom: "10px" }}>Education</div>
//                   <div className="flex flex-column gap-2">
//                     {[
//                       { value: "some_hs", label: "Some High School Coursework" },
//                       { value: "hs", label: "High School or equivalent" },
//                       { value: "cert", label: "Certification" },
//                       { value: "voc", label: "Vocational" },
//                       { value: "some_college", label: "Some College Coursework Completed" },
//                       { value: "associate", label: "Associate Degree" },
//                       { value: "bachelor", label: "Bachelor's Degree" },
//                       { value: "master", label: "Master's Degree" },
//                       { value: "phd", label: "Doctorate" },
//                       { value: "professional", label: "Professional" },
//                     ].map((opt) => (
//                       <div key={opt.value} className="flex align-items-center gap-2">
//                         <RadioButton inputId={`ed_${opt.value}`} value={opt.value} checked={education === opt.value} onChange={() => setEducation(opt.value)} />
//                         <label htmlFor={`ed_${opt.value}`} style={{ fontSize: "13px", cursor: "pointer" }}>
//                           {opt.label}
//                         </label>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </>
//           )}
//         </div>
//       </div>
//     </Dialog>
//   );
// };

// ─── Main Component ────────────────────────────────────────────────────────────

export const AdvancedOptionsInline = ({ onFilterChange }: { onFilterChange: (filters: any) => void }) => {
  const { suggestions, location, searchLocation, setLocation, skillEntries, removeSkill, updateSkillName, toggleSkillImportance, addSkill, jobTitleEntries, addJobTitle, removeJobTitle, updateJobTitle, radius, setRadius, booleanEntries, setBooleanEntries, searchType, setSearchType } = useSearchFilters();
  const [willingnessToRelocate, setWillingnessToRelocate] = useState(false);
  const [veteranCandidates, setVeteranCandidates] = useState(false);

  // ── Work Authorization
  const [workAuth, setWorkAuth] = useState("all");

  // ── Activity Indicators
  // const [lastActiveMaxAge, setLastActiveMaxAge] = useState("");
  const [resumeUpdatedMaxAge, setResumeUpdatedMaxAge] = useState("");
  const [resumeUpdatedMinAge, setResumeUpdatedMinAge] = useState("");

  // ── Resume Search Criteria
  // const [careerLevel, setCareerLevel] = useState<Record<string, boolean>>({
  //   executiveLevel: false,
  //   vicePresident: false,
  //   director: false,
  //   manager: false,
  // });
  // const [jobDuration, setJobDuration] = useState("");
  // const [jobTenureValue, setJobTenureValue] = useState("");
  const [yearsExp, setYearsExp] = useState("");
  const [expRequired, setExpRequired] = useState(false);
  const [degrees, setDegrees] = useState<DegreeEntry[]>([]);
  // const [companies, setCompanies] = useState<string[]>([]);
  const [companiesInput, setCompaniesInput] = useState<string>("");

  // ── Profile Search Criteria
  const [candidateName, setCandidateName] = useState("");
  const [jobType, setJobType] = useState<Record<string, boolean>>({
    fullTime: false,
    tempContract: false,
    intern: false,
    partTime: false,
    seasonal: false,
  });
  const [citizenship, setCitizenship] = useState<Record<string, boolean>>({
    usCitizen: false,
    permanentResident: false,
  });
  const [clearance, setClearance] = useState<Record<string, boolean>>({
    activeConfidential: false,
    activeSecret: false,
    activeTopSecret: false,
    activeTopSecretSCI: false,
    activeTSSCICIPoly: false,
    activeTSSCIFSPoly: false,
    otherActiveClearance: false,
  });
  // const [salaryPer, setSalaryPer] = useState("per_year");
  // const [salaryAmount, setSalaryAmount] = useState("");
  // const [includeWithoutSalary, setIncludeWithoutSalary] = useState(true);
  const [travel, setTravel] = useState("");
  const [education, setEducation] = useState("");
  // const [languageProficiencies, setLanguageProficiencies] = useState<LangEntry[]>([]);

  // ── Keywords / Boolean
  // const [keywords, setKeywords] = useState<string[]>([]);
  // const [booleanExpression, setBooleanExpression] = useState("");
  // const [booleanImportance, setBooleanImportance] = useState<"Required" | "NiceToHave">("NiceToHave");
  // const [workAuth, setWorkAuth] = useState("all");
  // const [showKeywords, setShowKeywords] = useState(true);
  const [excludeKeywords, setExcludeKeywords] = useState<string>("");
  const [resumeUpdatedRange, setResumeUpdatedRange] = useState<number | string>(0);
  const [resumeUpdatedFrom, setResumeUpdatedFrom] = useState<Date | null>(null);
  const [resumeUpdatedTo, setResumeUpdatedTo] = useState<Date | null>(null);

  //JobType
  const [targetJobTypeId, setTargetJobTypeId] = useState("");

  // ── Build + emit filters ────────────────────────────────────────────────────
  const companies = companiesInput
    .split(",")
    .map((c) => c.trim())
    .filter(Boolean);

  // console.log("[render] companiesInput:", companiesInput, "| companies:", companies);

  const buildFilters = () => ({
    // Candidate types
    excludeKeywords: excludeKeywords.trim()
      ? excludeKeywords
          .split(",")
          .map((k) => k.trim())
          .filter(Boolean)
      : undefined,
    willingnessToRelocate: willingnessToRelocate || undefined,
    veteranCandidates: veteranCandidates || undefined,
    // Work auth
    workAuthorizations:
      workAuth !== "all"
        ? [
            {
              authorization: workAuth,
              country: "US",
            },
          ]
        : undefined,
    // Activity
    // lastActiveMaxAge: lastActiveMaxAge ? Number(lastActiveMaxAge) : undefined,
    resumeUpdatedMaxAge: resumeUpdatedMaxAge ? Number(resumeUpdatedMaxAge) : undefined,
    resumeUpdatedMinAge: resumeUpdatedMinAge ? Number(resumeUpdatedMinAge) : undefined,
    // Resume criteria
    // // careerLevel,
    // jobTenure: jobTenureValue || undefined,
    yearsOfExperience: yearsExp ? { expression: yearsExp, importance: expRequired ? "Required" : "NiceToHave" } : undefined,
    degrees: degrees.length ? degrees : undefined,

    companies: companies.length ? companies : undefined,
    // Profile criteria
    candidateName: candidateName || undefined,
    jobType,
    citizenship,
    clearance,
    // salary: salaryAmount
    //   ? {
    //       minimum: parseInt(salaryAmount, 10),
    //       currencyAbbrev: "USD",
    //       includeResumesWithoutSalary: includeWithoutSalary,
    //       per: salaryPer,
    //     }
    //   : { includeResumesWithoutSalary: includeWithoutSalary },
    willingnessToTravel: travel || undefined,
    minEducationLevel: education || undefined,
    // languageProficiencyLevels: languageProficiencies.length ? languageProficiencies : undefined,
    // Keywords / Boolean
    // keywords: keywords.length ? keywords : undefined,
    // booleanExpression: booleanExpression ? { expression: booleanExpression, importance: booleanImportance } : undefined,
  });

  useEffect(() => {
    onFilterChange(buildFilters());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companiesInput, willingnessToRelocate, veteranCandidates, workAuth, resumeUpdatedMaxAge, resumeUpdatedMinAge, yearsExp, expRequired, degrees, candidateName, jobType, citizenship, clearance, travel, education]);

  // ── Label helper
  const label = (htmlFor: string, text: string) => (
    <label htmlFor={htmlFor} style={{ fontSize: "12px", cursor: "pointer" }}>
      {text}
    </label>
  );

  return (
    <div style={{ fontSize: "13px", color: "#333", padding: "16px" }}>
      <MonsterAccordionStyles />
      <Accordion multiple activeIndex={[0]} className="monster-accordion">
        {/* ══ Main Filter ══════════════════════════════════════════════════ */}
        <AccordionTab header={<TabHeader icon="pi-search" label="Main Filter" />}>
          <div style={{ marginBottom: "12px" }}>
            <div style={{ fontSize: "12px", fontWeight: 600, color: "#333", marginBottom: "6px" }}>Search Type</div>
            <div style={{ border: "1px solid #d9d9d9", padding: "7px", borderRadius: "5%" }}>
              <div className="flex align-items-center gap-4">
                <div className="flex align-items-center gap-2">
                  <RadioButton inputId="semantic" value="semantic" checked={searchType === "semantic"} onChange={() => setSearchType("semantic")} />
                  <label htmlFor="semantic" style={{ color: "black", fontSize: "11px", cursor: "pointer" }}>
                    Semantic Search
                  </label>
                </div>
                <div className="flex align-items-center gap-2">
                  <RadioButton inputId="boolean" value="boolean" checked={searchType === "boolean"} onChange={() => setSearchType("boolean")} />
                  <label htmlFor="boolean" style={{ color: "black", fontSize: "11px", cursor: "pointer" }}>
                    Boolean Keyword Search
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div style={{ marginBottom: "12px" }}>
            <div style={{ fontSize: "12px", fontWeight: 600, color: "#333", marginBottom: "6px" }}>Job Title</div>
            {jobTitleEntries.map((jt, idx) => (
              <div key={jt.id} style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "5px" }}>
                {jobTitleEntries.length > 1 ? (
                  <button onClick={() => removeJobTitle(jt.id)} style={{ background: "none", border: "none", cursor: "pointer", color: "#7c3aed", fontSize: "14px" }}>
                    ×
                  </button>
                ) : (
                  <span style={{ width: "18px" }} />
                )}
                <InputText value={jt.name} onChange={(e) => updateJobTitle(jt.id, e.target.value)} placeholder={idx === 0 ? "Cook, Developer, Nurse" : "Add title..."} className="border-2 border-purple-400 inline-block" style={{ color: "#111112", fontSize: "13px", fontWeight: "normal", backgroundColor: "#E9DDF5", width: "fit-content", padding: "4px 8px" }} />
              </div>
            ))}
            <button onClick={addJobTitle} style={{ background: "none", border: "none", cursor: "pointer", color: "#7c3aed", fontSize: "11px", fontWeight: 600, textDecoration: "underline", marginTop: "4px" }}>
              + Add another job title
            </button>
          </div>

          {searchType === "boolean" && (
            <div style={{ marginBottom: "12px" }}>
              <div style={{ fontSize: "12px", fontWeight: 600, color: "#333", marginBottom: "6px" }}>Boolean</div>
              <InputText value={booleanEntries?.name ?? ""} onChange={(e) => setBooleanEntries({ name: e.target.value, importance: "Required" })} placeholder="(e.g. Sales AND Marketing NOT Audit)" className="w-full" />
            </div>
          )}

          <div style={{ marginBottom: "12px" }}>
            <div style={{ fontSize: "12px", fontWeight: 600, color: "#333", marginBottom: "6px" }}>Location</div>
            <AutoComplete
              value={location}
              suggestions={suggestions}
              completeMethod={searchLocation}
              field="label"
              onChange={(e: any) => {
                const newValue = e.value.map((item: any) => {
                  if (typeof item === "object" && item?.label) return item;

                  let label = "";
                  if (typeof item === "string") {
                    label = item;
                  } else if (item?.Name) {
                    label = item.Name;
                  } else if (item?.Zip && !item?.City) {
                    label = item.Zip;
                  } else {
                    label = `${item?.City ?? ""}, ${item?.State ?? ""}`;
                  }

                  return typeof item === "string" ? { label } : { ...item, label };
                });
                setLocation(newValue);
              }}
              multiple
              itemTemplate={(item: any) => (
                <div>
                  {item?.Name ? (
                    <strong>{item?.Name || ""}</strong>
                  ) : (
                    <span>
                      <strong>{item.City}</strong>, {item.State}
                    </span>
                  )}
                </div>
              )}
              selectedItemTemplate={(item: any) => (typeof item === "string" ? item : item?.label ?? item?.Name ?? `${item?.City ?? ""}, ${item?.State ?? ""}`)}
              placeholder="Search by City, State or ZIP"
              className="border-none w-full"
              style={{ width: "100%" }}
            />
          </div>

          <div style={{ marginBottom: "12px" }}>
            <div style={{ fontSize: "12px", fontWeight: 600, color: "#333", marginBottom: "6px" }}>Radius</div>
            <Dropdown value={radius} options={radiusOptions} onChange={(e) => setRadius(e.value)} className="w-full" />
          </div>

          {searchType === "semantic" && (
            <div style={{ marginBottom: "0" }}>
              <div style={{ fontSize: "12px", fontWeight: 600, color: "#333", marginBottom: "6px" }}>Skills</div>
              <div style={{ border: "1px solid #d9d9d9", padding: "7px", borderRadius: "5%" }}>
                <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                  {skillEntries.map((skill: any, idx: any) => (
                    <div key={skill.id} style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      {skillEntries.length > 1 ? (
                        <button onClick={() => removeSkill(skill.id)} style={{ background: "none", border: "none", cursor: "pointer", color: "#9ca3af", padding: "0 2px", fontSize: "14px", lineHeight: 1, flexShrink: 0 }} title="Remove skill">
                          ×
                        </button>
                      ) : (
                        <span style={{ width: "18px", flexShrink: 0 }} />
                      )}

                      <InputText value={skill.name} onChange={(e) => updateSkillName(skill.id, e.target.value)} placeholder={idx === 0 ? "e.g. Java, React, SQL" : "Add skill..."} className="border-none shadow-none p-0" style={{ flex: 1, fontSize: "14px", color: "black", fontWeight: 600, minWidth: 0 }} />

                      <button
                        onClick={() => toggleSkillImportance(skill.id)}
                        style={{
                          flexShrink: 0,
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "5px",
                          padding: "3px 8px",
                          borderRadius: "20px",
                          border: `1.5px solid ${skill.importance === "Required" ? "#7c3aed" : "#16a34a"}`,
                          backgroundColor: skill.importance === "Required" ? "#ede9fe" : "#f0fdf4",
                          color: skill.importance === "Required" ? "#6d28d9" : "#15803d",
                          fontSize: "10px",
                          fontWeight: 700,
                          cursor: "pointer",
                          whiteSpace: "nowrap",
                          letterSpacing: "0.04em",
                          transition: "all 0.15s",
                        }}
                        title="Click to toggle Required / Nice to have"
                      >
                        <span style={{ width: "13px", height: "13px", borderRadius: "50%", border: `2px solid ${skill.importance === "Required" ? "#7c3aed" : "#16a34a"}`, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "8px" }}>{skill.importance === "Required" ? "R" : "N"}</span>
                        {skill.importance === "Required" ? "Required" : "Nice to have"}
                      </button>
                    </div>
                  ))}
                </div>

                <button onClick={addSkill} style={{ marginTop: "6px", background: "none", border: "none", cursor: "pointer", color: "#7c3aed", fontSize: "11px", fontWeight: 600, padding: "2px 0", textDecoration: "underline" }}>
                  + Add another skill or keyword
                </button>
              </div>
            </div>
          )}
        </AccordionTab>

        {/* ══ Candidate Type ═══════════════════════════════════════════════ */}
        <AccordionTab header={<TabHeader icon="pi-users" label="Candidate Type" />}>
          <div className="flex flex-column gap-2">
            <div className="flex align-items-center gap-2">
              <Checkbox inputId="willingnessToRelocate" checked={willingnessToRelocate} onChange={(e) => setWillingnessToRelocate(!!e.checked)} />
              <label htmlFor="willingnessToRelocate" style={{ fontSize: "12px", cursor: "pointer" }}>
                Limit result to candidates willing to relocate
              </label>
            </div>

            <div className="flex align-items-center gap-2">
              <Checkbox inputId="veteranCandidates" checked={veteranCandidates} onChange={(e) => setVeteranCandidates(!!e.checked)} />
              <label htmlFor="veteranCandidates" style={{ fontSize: "12px", cursor: "pointer" }}>
                Limit result to candidates designated as veteran candidates
              </label>
            </div>
          </div>
        </AccordionTab>

        {/* ══ Work Authorization ═══════════════════════════════════════════ */}
        <AccordionTab header={<TabHeader icon="pi-id-card" label="Work Authorization" />}>
          <div className="flex flex-column gap-2">
            {[
              { value: "all", label: "Show all job seekers" },
              { value: "AuthorizedToWorkForAnyEmployer", label: "Authorized for any employer" },
              { value: "AuthorizedToWorkForPresentEmployer", label: "Authorized for present employer" },
              { value: "RequiresSponsorship", label: "Requires sponsorship" },
            ].map((opt) => (
              <div key={opt.value} className="flex align-items-center gap-2">
                <RadioButton inputId={`wa_${opt.value}`} value={opt.value} checked={workAuth === opt.value} onChange={() => setWorkAuth(opt.value)} />
                <label htmlFor={`wa_${opt.value}`} style={{ fontSize: "12px", cursor: "pointer" }}>
                  {opt.label}
                </label>
              </div>
            ))}
          </div>
        </AccordionTab>

        {/* ══ Activity Indicators ══════════════════════════════════════════ */}
        <AccordionTab header={<TabHeader icon="pi-clock" label="Activity Indicators" />}>
          <div style={{ marginBottom: "12px" }}>
            <div style={{ fontSize: "12px", fontWeight: 600, color: "#333", marginBottom: "6px" }}>Resume Updated</div>
            <Dropdown
              value={resumeUpdatedRange}
              options={RESUME_UPDATED_OPTIONS}
              onChange={(e) => {
                const value = e.value;
                setResumeUpdatedRange(value);

                if (value === "custom") {
                  setResumeUpdatedFrom(null);
                  setResumeUpdatedTo(new Date());
                  setResumeUpdatedMaxAge("");
                  setResumeUpdatedMinAge("");
                  return;
                }

                if (value === "") {
                  setResumeUpdatedFrom(null);
                  setResumeUpdatedTo(null);
                  setResumeUpdatedMaxAge("");
                  setResumeUpdatedMinAge("");
                  return;
                }

                const from = new Date();
                from.setMinutes(from.getMinutes() - Number(value));
                setResumeUpdatedFrom(from);
                setResumeUpdatedTo(new Date());

                setResumeUpdatedMaxAge(String(value));
                setResumeUpdatedMinAge("");
              }}
              className="w-full"
              style={{ fontSize: "12px" }}
              placeholder="Any time"
            />
          </div>
          {resumeUpdatedRange !== "" && (
            <div className="flex gap-3">
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: "12px", fontWeight: 600, marginBottom: "6px" }}>From</div>
                <Calendar
                  value={resumeUpdatedFrom}
                  onChange={(e) => {
                    const from = e.value as Date;
                    setResumeUpdatedFrom(from);
                    if (resumeUpdatedRange === "custom" && from) {
                      const minutesAgo = Math.max(0, Math.round((Date.now() - from.getTime()) / 60000));
                      setResumeUpdatedMaxAge(String(minutesAgo));
                    }
                  }}
                  dateFormat="dd/mm/yy"
                  showIcon
                  maxDate={resumeUpdatedTo || new Date()}
                  style={{ width: "100%" }}
                />
              </div>

              <div style={{ flex: 1 }}>
                <div style={{ fontSize: "12px", fontWeight: 600, marginBottom: "6px" }}>To</div>
                <Calendar
                  value={resumeUpdatedTo}
                  onChange={(e) => {
                    const to = e.value as Date;
                    setResumeUpdatedTo(to);
                    if (resumeUpdatedRange === "custom" && to) {
                      const minutesAgo = Math.max(0, Math.round((Date.now() - to.getTime()) / 60000));
                      setResumeUpdatedMinAge(String(minutesAgo));
                    }
                  }}
                  dateFormat="dd/mm/yy"
                  showIcon
                  minDate={resumeUpdatedFrom || undefined}
                  maxDate={new Date()}
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          )}
        </AccordionTab>

        {/* ══ Resume Search Criteria ═══════════════════════════════════════ */}
        <AccordionTab header={<TabHeader icon="pi-file" label="Resume Search Criteria" />}>
          <div style={{ marginBottom: "12px" }}>
            <div style={{ fontSize: "12px", fontWeight: 600, color: "#333", marginBottom: "6px" }}>
              Exclude Keywords
              <span style={{ fontWeight: 400, color: "#888", marginLeft: "4px" }}>(comma separated)</span>
            </div>
            <InputText value={excludeKeywords} onChange={(e) => setExcludeKeywords(e.target.value)} placeholder="e.g. Java, react" className="w-full" style={{ fontSize: "12px" }} />
          </div>

          <div style={{ marginBottom: "12px" }}>
            <div style={{ fontSize: "12px", fontWeight: 600, color: "#333", marginBottom: "6px" }}>Years of Experience</div>
            <InputText value={yearsExp} onChange={(e) => setYearsExp(e.target.value)} placeholder="e.g. 4  |  2-3  |  5+  |  >5  |  <8" className="w-full mb-2" style={{ fontSize: "12px" }} />
            <div className="flex align-items-center gap-2">
              <Checkbox inputId="expRequired" checked={expRequired} onChange={(e) => setExpRequired(!!e.checked)} />
              {label("expRequired", "Required (not just nice-to-have)")}
            </div>
          </div>

          <div style={{ marginBottom: "12px" }}>
            <div style={{ fontSize: "12px", fontWeight: 600, color: "#333", marginBottom: "6px" }}>Degrees</div>
            <DegreesEditor entries={degrees} onChange={setDegrees} />
          </div>

          <div style={{ marginBottom: "0" }}>
            <div style={{ fontSize: "12px", fontWeight: 600, color: "#333", marginBottom: "6px" }}>
              Companies
              <span style={{ fontWeight: 400, color: "#888", marginLeft: "4px" }}>(comma separated)</span>
            </div>
            <InputText value={companiesInput} onChange={(e) => setCompaniesInput(e.target.value)} placeholder="e.g. Lockheed, Raytheon" className="w-full" style={{ fontSize: "12px" }} />
          </div>
        </AccordionTab>

        {/* ══ Profile Search Criteria ══════════════════════════════════════ */}
        <AccordionTab header={<TabHeader icon="pi-user" label="Profile Search Criteria" />}>
          <div style={{ marginBottom: "12px" }}>
            <div style={{ fontSize: "12px", fontWeight: 600, color: "#333", marginBottom: "6px" }}>Candidate Name</div>
            <InputText value={candidateName} onChange={(e) => setCandidateName(e.target.value)} placeholder="e.g. Mark, John Wayne" className="w-full" style={{ fontSize: "12px" }} />
          </div>

          <div style={{ marginBottom: "12px" }}>
            <div style={{ fontSize: "12px", fontWeight: 600, color: "#333", marginBottom: "8px" }}>Desired Job Type</div>
            <div className="flex flex-column gap-2">
              {[
                { key: "fullTime", label: "Full Time (WantsPermanent)" },
                { key: "tempContract", label: "Temporary / Contract" },
                { key: "intern", label: "Internship" },
                { key: "partTime", label: "Part Time" },
                { key: "seasonal", label: "Seasonal" },
              ].map((item) => (
                <div key={item.key} className="flex align-items-center gap-2">
                  <Checkbox inputId={`jt_${item.key}`} checked={jobType[item.key]} onChange={(e) => setJobType((prev) => ({ ...prev, [item.key]: !!e.checked }))} />
                  {label(`jt_${item.key}`, item.label)}
                </div>
              ))}
            </div>
          </div>

          <div style={{ marginBottom: "12px" }}>
            <div style={{ fontSize: "12px", fontWeight: 600, color: "#333", marginBottom: "8px" }}>Target Job Type</div>
            <div className="flex flex-column gap-2">
              {TARGET_JOB_TYPE_OPTIONS.filter((o) => o.value).map((opt) => (
                <div key={opt.value} className="flex align-items-center gap-2">
                  <RadioButton inputId={`tjtid_${opt.value}`} value={opt.value} checked={targetJobTypeId === opt.value} onChange={() => setTargetJobTypeId(opt.value)} />
                  {label(`tjtid_${opt.value}`, opt.label)}
                </div>
              ))}
            </div>
          </div>

          <div style={{ marginBottom: "12px" }}>
            <div style={{ fontSize: "12px", fontWeight: 600, color: "#333", marginBottom: "8px" }}>Citizenship / Legal Status</div>
            <div className="flex flex-column gap-2">
              {[
                { key: "usCitizen", label: "US Citizen" },
                { key: "permanentResident", label: "Permanent Resident" },
              ].map((item) => (
                <div key={item.key} className="flex align-items-center gap-2">
                  <Checkbox inputId={`c_${item.key}`} checked={citizenship[item.key]} onChange={(e) => setCitizenship((prev) => ({ ...prev, [item.key]: !!e.checked }))} />
                  {label(`c_${item.key}`, item.label)}
                </div>
              ))}
            </div>
          </div>

          <div style={{ marginBottom: "12px" }}>
            <div style={{ fontSize: "12px", fontWeight: 600, color: "#333", marginBottom: "8px" }}>Security Clearance (US)</div>
            <div className="flex flex-column gap-2">
              {[
                { key: "unspecified", label: "Unspecified" },
                { key: "activeConfidential", label: "Active Confidential" },
                { key: "activeSecret", label: "Active Secret" },
                { key: "activeTopSecret", label: "Active Top Secret" },
                { key: "activeTopSecretSCI", label: "Active Top Secret / SCI" },
                { key: "activeTSSCICIPoly", label: "Active TS/SCI – CI Polygraph" },
                { key: "activeTSSCIFSPoly", label: "Active TS/SCI – FS Polygraph" },
                { key: "otherActiveClearance", label: "Other Active Clearance" },
              ].map((item) => (
                <div key={item.key} className="flex align-items-center gap-2">
                  <Checkbox inputId={`sc_${item.key}`} checked={clearance[item.key]} onChange={(e) => setClearance((prev) => ({ ...prev, [item.key]: !!e.checked }))} />
                  {label(`sc_${item.key}`, item.label)}
                </div>
              ))}
            </div>
          </div>

          {/* <div style={{ marginBottom: "12px" }}>
            <div style={{ fontSize: "12px", fontWeight: 600, color: "#333", marginBottom: "6px" }}>Desired Salary</div>
            <Dropdown value={salaryPer} options={salaryPerOptions} onChange={(e) => setSalaryPer(e.value)} className="w-full mb-2" style={{ fontSize: "12px" }} />
            <Dropdown value={salaryAmount} options={salaryAmountOptions} onChange={(e) => setSalaryAmount(e.value)} className="w-full mb-2" style={{ fontSize: "12px" }} placeholder="Any" />
            <div className="flex align-items-center gap-2">
              <Checkbox inputId="inclSalary" checked={includeWithoutSalary} onChange={(e) => setIncludeWithoutSalary(!!e.checked)} />
              {label("inclSalary", "Include candidates without salary info")}
            </div>
          </div> */}

          <div style={{ marginBottom: "12px" }}>
            <div style={{ fontSize: "12px", fontWeight: 600, color: "#333", marginBottom: "8px" }}>Willing to Travel</div>
            <div className="flex flex-column gap-2">
              {[
                { value: "NoTravelRequired", label: "No travel required" },
                { value: "UpTo25PercentTravel", label: "Up to 25%" },
                { value: "UpTo50PercentTravel", label: "Up to 50%" },
                { value: "UpTo75PercentTravel", label: "Up to 75%" },
                { value: "OneHundredPercentTravel", label: "Up to 100%" },
              ].map((opt) => (
                <div key={opt.value} className="flex align-items-center gap-2">
                  <RadioButton inputId={`tr_${opt.value}`} value={opt.value} checked={travel === opt.value} onChange={() => setTravel(opt.value)} />
                  {label(`tr_${opt.value}`, opt.label)}
                </div>
              ))}
            </div>
          </div>

          <div style={{ marginBottom: "0" }}>
            <div style={{ fontSize: "12px", fontWeight: 600, color: "#333", marginBottom: "8px" }}>Minimum Education Level</div>
            <div className="flex flex-column gap-2">
              {[
                { value: "SomeHighSchoolCoursework", label: "Some High School Coursework" },
                { value: "HighSchoolOrEquivalent", label: "High School or Equivalent" },
                { value: "Certification", label: "Certification" },
                { value: "Vocational", label: "Vocational" },
                { value: "SomeCollegeCourseworkCompleted", label: "Some College Coursework" },
                { value: "AssociateDegree", label: "Associate Degree" },
                { value: "BachelorsDegree", label: "Bachelor's Degree" },
                { value: "MastersDegree", label: "Master's Degree" },
                { value: "Doctorate", label: "Doctorate" },
                { value: "Professional", label: "Professional" },
              ].map((opt) => (
                <div key={opt.value} className="flex align-items-center gap-2">
                  <RadioButton inputId={`ed_${opt.value}`} value={opt.value} checked={education === opt.value} onChange={() => setEducation(opt.value)} />
                  {label(`ed_${opt.value}`, opt.label)}
                </div>
              ))}
            </div>
          </div>
        </AccordionTab>
      </Accordion>
    </div>
  );
};
